import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '@chakra-ui/react';

import { formatParticipantURL } from '../../../utils/functions/ad-board-utils';

export const HighlightMentionLink = ({
  value,
  userId,
}: {
  value: string;
  userId: string;
}) => {
  const { colors } = useTheme();
  const location = useLocation();

  const participantLink = formatParticipantURL(location, userId);

  return (
    <Link
      to={participantLink}
      key={value}
      style={{
        color: colors.keyops.midnightBlue,
        backgroundColor: colors.keyops.alpha20teal,
      }}
    >
      {value}
    </Link>
  );
};

export const parseAndHighlightMentions = (
  input?: string,
  noHighlight?: boolean
): ReactNode[] => {
  if (!input) return [];

  // Updated regex to capture both `id` and `value`
  const mentionedIdAndValueRegex =
    /\[\[{"id":"(\d+)","value":"([^"]+)","prefix":"@"}]]/g;

  const elements: React.ReactNode[] = [];
  let lastIndex = 0; // To track the position in the string where the last match ended, to keep the plain text between the current match and the previous one.

  let match;
  while ((match = mentionedIdAndValueRegex.exec(input)) !== null) {
    const userId = match[1]; // Capture the user id
    const value = match[2]; // Capture the value

    // Start index of this match
    const startIndex = match.index;

    // If there’s any text before the current match, it's pushed into the elements array.
    // This ensures that the text between matches is preserved.
    if (lastIndex < startIndex) {
      elements.push(input.slice(lastIndex, startIndex));
    }

    // Push the mention span
    elements.push(
      noHighlight ? (
        `@${value}`
      ) : (
        <HighlightMentionLink value={value} userId={userId} />
      )
    );

    // Ensures == the next match will continue from the correct position in the string.
    lastIndex = mentionedIdAndValueRegex.lastIndex;
  }

  // Push remaining plain text after the last match
  if (lastIndex < input?.length) {
    elements.push(input.slice(Math.max(0, lastIndex)));
  }

  return elements;
};
